import { GlobalParams, GlobalParticipatedAdsResponse } from '@/types/supports'

import { offerwallGlobalApi } from '../axiosInstance'

export const fetchGlobalParticipatedAds = async (params: GlobalParams): Promise<GlobalParticipatedAdsResponse> => {
  const { data } = await offerwallGlobalApi.get<GlobalParams, GlobalParticipatedAdsResponse>(
    '/support_tickets/participates',
    {
      params: params,
      headers: {}
    }
  )

  return data
}
